import { useEffect, useState } from "react";
import { api } from "@/api";

export default function LegalPage({ section }) {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/content").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return <div className="p-20 text-center text-zinc-500">Loading…</div>;
  const s = c[section] || {};

  return (
    <div data-testid={`${section}-page`} className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
      <span className="text-[11px] uppercase tracking-[0.3em] text-[#ff3b30]">Legal</span>
      <h1 data-testid={`${section}-title`} className="display text-4xl sm:text-5xl uppercase tracking-tighter font-bold mt-4 leading-[0.95]">{s.title}</h1>
      <div data-testid={`${section}-body`} className="mt-8 space-y-5">
        {String(s.body || "").split("\n\n").map((p, i) => (
          <p key={i} className="text-sm text-zinc-300 leading-relaxed whitespace-pre-line">{p}</p>
        ))}
      </div>
    </div>
  );
}
